export default __webpack_public_path__ + "static/media/corporate_culture_pic.8d004893.png";